import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReviewEntryDocumentViewerWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  padding: ${Spacing.S24};
  position: relative;
`
